import {createFileRoute, redirect} from '@tanstack/react-router'

/** Legacy short-prefix URL → /live/ryder-cup/{slug-or-uid}. */
export const Route = createFileRoute('/live/rc/$ryder_cup_uid')({
    beforeLoad: ({params}) => {
        throw redirect({to: `/live/ryder-cup/${params.ryder_cup_uid}`} as any)
    },
})
